import apiInternal from './servers/apiInternal';

export interface AutorequestRequest {
  id: string;
  status: string;
  source: string;
  platform: string;
  query: string;
  court?: string;
  search?: string;
  uf?: string;
  param?: {
    key: string;
    value: string;
  };
  makeDownload?: boolean;
  respondedAt?: string;
  createdAt: string;
  credentialId?: string;
  credentials?: boolean;
}

export interface AutorequestDetailsResponse {
  success: boolean;
  data: {
    id: string;
    key: string;
    value: string;
    requests: AutorequestRequest[];
    createdAt: string;
  };
  message?: string;
}

const autorequestDetails = {
  /**
   * Busca os detalhes de um autorequest por ID
   */
  getDetails: async (id: string): Promise<AutorequestDetailsResponse> => {
    const res = await apiInternal.get(`/autorequest/admin/${id}`);
    return res.data;
  },
};

export default autorequestDetails;
